import { PropsWithChildren, Ref } from 'react';

import { Box } from '../../../box/components/Box/Box';

interface Props extends PropsWithChildren {
   disableGutters?: boolean;
   ref?: Ref<HTMLDivElement>;
}

export const FlyoutContent = ({ disableGutters = false, children, ref }: Props) => (
   <Box ref={ref} gap="md" spacing={{ x: disableGutters ? 'none' : 'md', top: 'none', bottom: 'lg' }} flex="1" grow="1" overflowY="auto" direction="column">
      {children}
   </Box>
);
